import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { INewOrTemplateDialogComponentData } from './interfaces';
import { INewOrTemplateDialogComponentResult, NewOrTemplateDialogSelectionType } from './enums';
import { TRANSLATION_MAP } from '../const';

@Component({
    templateUrl: 'new-or-template-dialog.component.html',
    styleUrls: ['new-or-template-dialog.component.css'],
    standalone: false
})
export class NewOrTemplateDialogComponent {

    translations = TRANSLATION_MAP;

    constructor(
        private matDialog: MatDialogRef<NewOrTemplateDialogComponent, INewOrTemplateDialogComponentResult>,
        @Inject(MAT_DIALOG_DATA) public data: INewOrTemplateDialogComponentData
    ) {
    }

    onFromScratchSelected(): void {
        const result: INewOrTemplateDialogComponentResult = { selectionType: NewOrTemplateDialogSelectionType.fromScratch };
        this.matDialog.close(result);
    }

    onFromTemplateSelected(): void {
        const result: INewOrTemplateDialogComponentResult = { selectionType: NewOrTemplateDialogSelectionType.fromTemplate };
        this.matDialog.close(result);
    }

    onFromPredefinedSelected(): void {
        const result: INewOrTemplateDialogComponentResult = { selectionType: NewOrTemplateDialogSelectionType.fromPreset };
        this.matDialog.close(result);
    }

    onFromFileSelected(): void {
        const result: INewOrTemplateDialogComponentResult = { selectionType: NewOrTemplateDialogSelectionType.fromFile };
        this.matDialog.close(result);
    }
}
